<template>
  <div>
    <el-form-item :label="(isChildList ? '' : (element.name == '按钮'? '' : element.name ))" :prop="element.model" :label-width="(isChildList ? '0px' : (!element.name ? '5px' : element.options.labelwidth))" :rules="componentsRules(element)" v-if="allcomponentsIsShow(element) && element.type !== 'enclosure'">
      <!-- input输入框 -->
      <template v-if="element.type == 'input' && !element.options.isThousandthPercentile">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" style="width:100%" :placeholder="element.options.placeholder" @input="inputChange"></el-input>
      </template>
      <!-- inputGoto转到组件 -->
      <template v-if="element.type == 'inputGoto'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else disabled placeholder="请输入内容" v-model="formModel[element.model]">
          <template slot="append">
            <el-dropdown @command="inputGoto">
              <span class="el-dropdown-link">
                <i class="el-icon-position"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="'goto'+index" v-for="(item,index) in element.options.gotoAppList" :key="index">
                  <i class="el-icon-position"></i>
                  转到 - {{item.appDesc}}
                </el-dropdown-item>
                <el-dropdown-item command="choose" v-if="!allcomponentsDisabledfun(element)">
                  <i class="el-icon-search"></i>
                  选择
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-input>
        <popup-components ref="popupComponents" :childName="childName" :element="element" @updateChoose='updateChoose' :isChild="isChild"></popup-components>
      </template>
      <!-- input输入框 -- 千分位 -->
      <template v-if="element.type == 'input' && element.options.isThousandthPercentile">
        <span v-if="!isEdit">{{noEdit(element,"input")}}</span>
        <el-inpu size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model.trim="formModel[element.model + 'Thousands']" style="width:100%" :placeholder="element.options.placeholder" @input="comdifyInput($event,element,formModel)" @blur="comdifyBlur($event,element,formModel)"></el-inpu>
      </template>
      <!-- textarea输入框 -->
      <template v-if="element.type == 'textarea'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" type="textarea" :maxlength="element.options.maxlength ? element.options.maxlength : ''" show-word-limit v-model="formModel[element.model]" style="width:100%" :placeholder="element.options.placeholder" :autosize="{ minRows: element.options.minRows ? element.options.minRows : 2 ,maxRows:element.options.maxRows ? element.options.maxRows : ''}" @input="inputChange"></el-input>
      </template>
      <!-- number计数器输入框 -->
      <template v-if="element.type == 'number'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input-number size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" controls-position="right" style="width:100%" :min="element.options.min" :max="element.options.max" @change="computationalDomain(element)"></el-input-number>
      </template>
      <!-- numbers输入框 -->
      <template v-if="element.type == 'numbers'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model.number="formModel[element.model]" style="width:100%" type="number" :placeholder="element.options.placeholder" :min="element.options.min" :max="element.options.max" @input="computationalDomain(element)"></el-input>
      </template>
      <!-- 时间选择器 -->
      <template v-if="element.type == 'time'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-time-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :is-range="element.options.isRange" :placeholder="element.options.placeholder" :start-placeholder="element.options.startPlaceholder" :end-placeholder="element.options.endPlaceholder" :arrowControl="element.options.arrowControl" style="width:100%" value-format="HH:mm:ss" @change="computationalDomain(element)"></el-time-picker>
      </template>
      <!-- 日期选择器 -->
      <template v-if="element.type == 'date'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-date-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :type="element.options.type" :is-range="element.options.isRange" :placeholder="element.options.placeholder" :start-placeholder="element.options.startPlaceholder" :end-placeholder="element.options.endPlaceholder" style="width:100%" value-format="yyyy-MM-dd" @change="computationalDomain(element)"></el-date-picker>
      </template>
      <!-- 日期时间选择器 -->
      <template v-if="element.type == 'datetime'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-date-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :type="element.options.type" :is-range="element.options.isRange" :placeholder="element.options.placeholder" :start-placeholder="element.options.startPlaceholder" :end-placeholder="element.options.endPlaceholder" style="width:100%" value-format="yyyy-MM-dd HH:mm:ss" :default-time="new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()" @change="computationalDomain(element)"></el-date-picker>
      </template>
      <!-- 综合选择器 年 -->
      <template v-if="element.type == 'allDatePicker' && element.options.type == 'year'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-date-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :type="element.options.type" :is-range="element.options.isRange" :placeholder="element.options.placeholder" :start-placeholder="element.options.startPlaceholder" :end-placeholder="element.options.endPlaceholder" style="width:100%" value-format="yyyy" @change="computationalDomain(element)"></el-date-picker>
      </template>
      <!-- 综合选择器 月 -->
      <template v-if="element.type == 'allDatePicker' && element.options.type == 'month'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-date-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :type="element.options.type" :is-range="element.options.isRange" :placeholder="element.options.placeholder" :start-placeholder="element.options.startPlaceholder" :end-placeholder="element.options.endPlaceholder" style="width:100%" value-format="yyyy-MM" @change="computationalDomain(element)"></el-date-picker>
      </template>
      <!-- 综合选择器 周 -->
      <template v-if="element.type == 'allDatePicker' && element.options.type == 'week'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-date-picker size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model]" :type="element.options.type" :placeholder="element.options.placeholder" style="width:100%" format="yyyy 第 WW 周" @change="computationalDomain(element)"></el-date-picker>
      </template>
      <!-- 数据字典下拉框单选  -->
      <template v-if="element.type == 'select' && element.options.remote == 1 && !element.options.multiple">
        <span v-if="!isEdit">{{noEdit(element,"select")}}</span>
        <el-select size="small" v-else :disabled="allcomponentsDisabledfun(element)" clearable :title="formModel[element.model]" v-model="formModel[element.model]" :placeholder="element.options.placeholder" style="width:100%" @change="selectChange">
          <el-option v-for="item in dictSelectData" :key="item.id" :value="item.code" :label="item.name">{{item.name}}</el-option>
        </el-select>
        <!-- 客户化组件 -->
        <customizationComponents v-if="element.options.isCustomizedprocessing" ref="customizationComponents"></customizationComponents>
      </template>
      <!-- 数据字典下拉框多选  -->
      <template v-if="element.type == 'select' && element.options.remote == 1 && element.options.multiple">
        <span v-if="!isEdit">{{noEdit(element,"select")}}</span>
        <el-select size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model + 'SelectBox']" :multiple="element.options.multiple" :placeholder="element.options.placeholder" style="width:100%" @change="selectChange">
          <el-option v-for="item in dictSelectData" :key="item.id" :value="item.code" :label="item.name">{{item.name}}</el-option>
        </el-select>
        <!-- 客户化组件 -->
        <customizationComponents v-if="element.options.isCustomizedprocessing" ref="customizationComponents"></customizationComponents>
      </template>
      <!-- 远端数据下拉框单选  -->
      <template v-if="element.type == 'select' && element.options.remote == 2 && !element.options.multiple">
        <span v-if="!isEdit">{{noEdit(element,"select")}}</span>
        <el-select size="small" v-else :disabled="allcomponentsDisabledfun(element)" clearable :title="formModel[element.model]" v-model="formModel[element.model]" :placeholder="element.options.placeholder" style="width:100%" @change="selectChange">
          <el-option v-for="item in remoteSelectData" :key="item.id" :value="item[element.options.remoteData.value]" :label="item[element.options.remoteData.label]"></el-option>
        </el-select>
        <!-- 客户化组件 -->
        <customizationComponents v-if="element.options.isCustomizedprocessing" ref="customizationComponents"></customizationComponents>
      </template>
      <!-- 远端数据下拉框多选  -->
      <template v-if="element.type == 'select' && element.options.remote == 2 && element.options.multiple">
        <span v-if="!isEdit">{{noEdit(element,"select")}}</span>
        <el-select size="small" v-else :disabled="allcomponentsDisabledfun(element)" :title="formModel[element.model]" v-model="formModel[element.model + 'SelectBox']" :multiple="element.options.multiple" :placeholder="element.options.placeholder" style="width:100%" @change="selectChange">
          <el-option v-for="item in remoteSelectData" :key="item.id" :value="item[element.options.remoteData.value]" :label="item[element.options.remoteData.label]"></el-option>
        </el-select>
      </template>
      <!-- switch开关 -->
      <template v-if="element.type=='switch'">
        <span v-if="!isEdit">{{noEdit(element,"switch")}}</span>
        <el-switch v-else :disabled="allcomponentsDisabledfun(element)" v-model="formModel[element.model]" :active-value="'1' || 1" :inactive-value="'0' || 0" @change="switchChange"></el-switch>
      </template>
      <!-- 单选弹出框 -->
      <template v-if="element.type == 'inputBtn' && !element.options.isBatchChoose">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :title="formModel[element.model]" v-model="formModel[element.model]" style="width:100%" :disabled="element.options.remoteData.iscanbeinput ? false : true" :placeholder="element.options.placeholder">
          <i slot="suffix" class="el-icon-circle-close input-suffix-icon" v-show="!!formModel[element.model]" @click.stop="clearInput(element)"></i>
          <el-button :disabled="allcomponentsDisabledfun(element)" @click="inputBtnClick(element)" slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <popup-components ref="popupComponents" :childName="childName" :element="element" @updateChoose='updateChoose' :isChild="isChild" :isChildList="isChildList" :currentListchildData="currentListchildData"></popup-components>
        <!-- 客户化组件 -->
        <customizationComponents v-if="element.options.isCustomizedprocessing" ref="customizationComponents"></customizationComponents>
      </template>
      <!-- 多选弹出框 -->
      <template v-if="element.type == 'inputBtn' && element.options.isBatchChoose">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :title="formModel[element.model]" v-model="formModel[element.model]" style="width:100%" :disabled="element.options.remoteData.iscanbeinput ? false : true" :placeholder="element.options.placeholder">
          <i slot="suffix" class="el-icon-circle-close input-suffix-icon" v-show="!!formModel[element.model]" @click.stop="clearInput(element)"></i>
          <el-button :disabled="allcomponentsDisabledfun(element)" @click="inputBtnClick(element)" slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <batch-popup-components ref="batchPopupComponents" :element="element" @updateChoose='updateChoose' :isChild="isChild"></batch-popup-components>
      </template>
      <!-- 树弹出框 -->
      <template v-if="element.type == 'treeInputBtn'">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-input size="small" v-else :title="formModel[element.model]" v-model="formModel[element.model]" style="width:100%" :disabled="element.options.iscanbeinput ? false : true" :placeholder="element.options.placeholder">
          <i slot="suffix" class="el-icon-circle-close input-suffix-icon" v-show="!!formModel[element.model]" @click.stop="clearInput(element)"></i>
          <el-button :disabled="allcomponentsDisabledfun(element)" @click="treeinputBtnClick(element)" slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <tree-popup-components ref="treePopupComponents" :element="element" @updateChooseTree='updateChoose' :isChild="isChild"></tree-popup-components>
      </template>
      <!-- 远端数据 复选框 -->
      <template v-if="element.type == 'checkbox' && element.options.remote == 2">
        <span v-if="!isEdit">{{noEdit(element,"checkbox")}}</span>
        <el-checkbox-group size="small" v-else :disabled="allcomponentsDisabledfun(element)" v-model="formModel[element.model + 'CheckboxModel']" style="width:100%" @change="checkboxgroupChange">
          <el-checkbox :style="{display: element.options.inline ? 'inline-block' : 'block'}" :label="item[element.options.remoteData.value]" v-for="(item, index) in element.options.options" :key="index">{{item[element.options.remoteData.label]}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <!-- 数据字典 复选框 -->
      <template v-if="element.type == 'checkbox' && element.options.remote == 1">
        <span v-if="!isEdit">{{noEdit(element,"checkbox")}}</span>
        <el-checkbox-group size="small" v-else :disabled="allcomponentsDisabledfun(element)" v-model="formModel[element.model + 'CheckboxModel']" style="width:100%" @change="checkboxgroupChange">
          <el-checkbox :style="{display: element.options.inline ? 'inline-block' : 'block'}" :label="item.code" v-for="(item, index) in element.options.options" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <!-- 单选框组 远端数据 -->
      <template v-if="element.type == 'radio' && element.options.remote == 2">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-radio-group size="small" v-else :disabled="allcomponentsDisabledfun(element)" v-model="formModel[element.model]" style="width:100%" @change="radiogroupChange">
          <el-radio :style="{display: element.options.inline ? 'inline-block' : 'block'}" :label="item.value" v-for="(item, index) in element.options.options" :key="index">{{element.options.showLabel ? item.label : item.value}}</el-radio>
        </el-radio-group>
      </template>
      <!-- 单选框组  数据字典-->
      <template v-if="element.type == 'radio' && element.options.remote == 1">
        <span v-if="!isEdit">{{formModel[element.model]}}</span>
        <el-radio-group size="small" v-else :disabled="allcomponentsDisabledfun(element)" v-model="formModel[element.model]" style="width:100%" @change="radiogroupChange">
          <el-radio :style="{display: element.options.inline ? 'inline-block' : 'block'}" :label="item.code" v-for="(item, index) in element.options.options" :key="index">{{item.name}}</el-radio>
        </el-radio-group>
      </template>
      <!-- 富文本编辑器 -->
      <template v-if="element.type == 'editor'">
        <div v-if="!isEdit" v-html="formModel[element.model]"></div>
        <vue-editor v-else v-model="formModel[element.model]" style="width:100%"></vue-editor>
      </template>
    </el-form-item>
    <template v-if="permissionSetting(element.options.invisibleRoleList,'look') && (element.type == 'iframe' || element.type == 'enclosure' )">
      <!-- 附件列表 -->
      <template v-if="element.type == 'enclosure' && element.options.showImages !== 0">
        <uploadfileComponents ref="uploadfileComponents" :element="element" :isChild="isChild"></uploadfileComponents>
      </template>
      <!-- 附件图片 -->
      <template v-if="element.type == 'enclosure' && element.options.showImages == 0">
        <uploadimageComponents ref="uploadimageComponents" :element="element" :isChild="isChild"></uploadimageComponents>
      </template>
      <!-- iframe组件 -->
      <template v-if="element.type == 'iframe'">
        <iframeComponents ref="iframeComponents" :element="element"></iframeComponents>
      </template>
    </template>
  </div>
</template>

<script>

import popupComponents from "./popupComponents"
import batchPopupComponents from "./batchPopupComponents"
import uploadfileComponents from './uploadfileComponents'
import uploadimageComponents from './uploadimageComponents'
import iframeComponents from './iframeComponents'
import { VueEditor } from "vue2-editor";
import treePopupComponents from "./treePopupComponents";
import customizationComponents from "@/page/zhonglv/zhonglv.vue"  //客户化处理组件
export default {
  name: "widgetFormItem",
  props: ["element", "isChild", "currentListchildData", "isChildList", "childName", "parentRowData", "childDetailJson"],
  components: { popupComponents, batchPopupComponents, uploadfileComponents, uploadimageComponents, iframeComponents, VueEditor, treePopupComponents, customizationComponents },
  data() {
    return {
      basic_url: Config.dev_url,
      dictSelectData: [],
      remoteSelectData: [],
    }
  },
  computed: {
    //当前应用的json
    jsonData() {
      return this.$store.state.jsonData
    },
    //主表信息
    detailInfos() {
      return this.$store.state.detailInfo
    },
    //子表信息
    currentAppChildRowData() {
      if (this.isChildList) {
        return this.currentListchildData
      } else {
        return this.$store.state.currentAppChildRowData
      }
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
    //当前表单绑定数据
    formModel() {
      return this.isChild ? this.currentAppChildRowData : this.detailInfos
    },
    //是否可编辑主表信息
    isCanEditDetailInfo() {
      return this.$store.state.isCanEditDetailInfo
    },
    //是否可编辑子表信息
    isCanEditChildInfo() {
      return this.$store.state.isCanEditChildInfo
    },
    //页面是否可编辑
    isEdit() {
      return true
      // this.isChild ? (this.isChildList ? this.isChildList : this.isCanEditChildInfo) : this.isCanEditDetailInfo
    },
    //详情页主表json
    detailJosnArr() {
      return this.$store.state.detailJosnArr
    },
    //子表信息
    childrensInfo() {
      return this.$store.state.childrensInfo
    },
  },
  methods: {
    //存储当前子表变化得数据 -- 为分页缓存数据做准备
    saveChildChangeData() {
      if (this.isChildList) {
        if (!!this.currentAppChildRowData.id) {
          if (!!this.childrensInfo[this.childName + 'ChangeData']) {
            var str = this.childrensInfo[this.childName + 'ChangeData'].some((item) => {
              return this.currentAppChildRowData.id == item.id
            })
          }
          if (!str) {
            if (!!this.childrensInfo[this.childName + 'ChangeData']) {
              this.childrensInfo[this.childName + 'ChangeData'].push(this.currentAppChildRowData)
            } else {
              this.childrensInfo[this.childName + 'ChangeData'] = []
              this.childrensInfo[this.childName + 'ChangeData'].push(this.currentAppChildRowData)
            }
          }
        }
      }
    },
    //转到组件
    inputGoto(val) {
      //列表行上存在转到，存储数据
      if (this.isChildList) {
        var frameindex = Number(localStorage.getItem("iframeindex"));
        parent.putChildShareValue(frameindex, this.currentAppChildRowData);
      }
      if (val.indexOf("goto") > -1) {
        var key = Number(val.substr(4));
        var elementval = this.formModel[this.element.model];
        var routeurl = "";
        //如果点击的转到的input框中有数据，转到后跳转到详情页面
        if (!!elementval) {
          //获取要转到的应用的详情页数据
          var params = {
            page: 1,
            limit: 10,
          }
          var bringValue = this.element.options.gotoAppList[key].bringValue;
          var bringVal = bringValue.split(",");
          //获取该字段转到后的应用对应的字段，放到查询条件中，查询转到后应用的详细信息
          for (let i = 0; i < bringVal.length; i++) {
            let field = bringVal[i].split("=");
            if (this.element.model == field[0]) {
              params[field[1] + "_wheres"] = elementval;
            }
          }
          var url = Config.dev_url + '/api-apps/app/' + this.element.options.gotoAppList[key].appName;
          this.$axios.post(url, params).then((res) => {
            var selectData = res.data.data[0];
            if (!!selectData && !!selectData.id) {
              routeurl = "?gotodetailid=" + selectData.id;
            } else {
              routeurl = "?gotodetailid=";
            }
            var that = this;
            console.log(this.element.options.gotoAppList[key].appDesc)
            let routeData = this.$router.resolve({
              path: '/Application/' + this.element.options.gotoAppList[key].appName + routeurl,
              query: {
                isgo: 'yes',
                appDesc: this.element.options.gotoAppList[key].appDesc,
                relationship: this.element.options.gotoAppList[key].relationship,
                bringValue: this.element.options.gotoAppList[key].bringValue,
                disabled: this.allcomponentsDisabledfun(this.element),
                isfromChild: this.isChild
              }
            });
            let index = parent.layer.open({
              type: 2,
              area: ['100%', '100%'],
              maxmin: false,
              title: false,
              closeBtn: 0,
              content: routeData.href
            });
            layer.full(index);
          });
        } else {
          //如果点击的转到的input框中没有数据，转到后跳转到列表页面
          let routeData = this.$router.resolve({
            path: '/Application/' + this.element.options.gotoAppList[key].appName,
            query: {
              isgo: 'yes',
              appDesc: this.element.options.gotoAppList[key].appDesc,
              relationship: this.element.options.gotoAppList[key].relationship,
              bringValue: this.element.options.gotoAppList[key].bringValue,
              disabled: this.allcomponentsDisabledfun(this.element),
              isfromChild: this.isChild
            }
          });
          let index = parent.layer.open({
            type: 2,
            title: false,
            area: ['100%', '100%'],
            maxmin: false,
            closeBtn: 0,
            content: routeData.href
          });
          layer.full(index);
        }
      } else {
        this.inputBtnClick(this.element);
      }
      this.saveChildChangeData()
      console.log(val, "转到发生了变化")
      this.$store.commit('setDataChangeStatus', 1)
    },
    inputChange(val) {
      this.saveChildChangeData()
      console.log(val, "输入框发生了变化")
      this.$store.commit('setDataChangeStatus', 1)
    },
    selectChange(val) {
      this.saveChildChangeData()
      console.log(val, "下拉框发生了变化")
      if (this.element.options.isCustomizedprocessing) {
        this.$refs.customizationComponents.selectChange(this.element, val, this.formModel)
      }
      this.$store.commit('setDataChangeStatus', 1)
    },
    radiogroupChange(val) {
      console.log(val, "单选框发生了变化")
      this.saveChildChangeData()
      this.$store.commit('setDataChangeStatus', 1)
    },
    checkboxgroupChange(val) {
      console.log(val, "checkbox发生了变化")
      this.saveChildChangeData()
      this.$store.commit('setDataChangeStatus', 1)
    },
    switchChange(val) {
      console.log(val, this.element, "开关发生了变化")
      this.saveChildChangeData()
      this.$store.commit('setDataChangeStatus', 1)
    },
    //千分位输入时转换
    comdifyInput(val, element, data) {
      this.saveChildChangeData()
      let inp = val.replace(/,/g, "")
      data[element.model + "Thousands"] = (inp + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
      data[element.model] = (inp + '').replace(/,/g, "")
    },
    //千分位失去焦点验证
    comdifyBlur(event, element, data) {
      let val = data[element.model]
      if (/[^\d^\.]+/g.test(val)) {
        data[element.model + "Thousands"] = ""
        data[element.model] = ""
      }
    },
    //页面不可编辑时对数据得处理
    noEdit(element, str) {
      if (str == "select") {
        if (element.options.remote == 1 && !element.options.multiple) {
          var model = this.formModel[element.model]
          var resultModel = ""
          this.dictSelectData.forEach((item) => {
            if (item.code == model) {
              resultModel = item.name
            }
          })
          return resultModel
        } else if (element.options.remote == 1 && element.options.multiple) {
          var model = this.formModel[element.model + 'SelectBox']
          var resultModelArr = []
          for (var i = 0; i < model.length; i++) {
            this.dictSelectData.forEach((item) => {
              if (item.code == model[i]) {
                resultModelArr.push(item.name)
              }
            })
          }
          return resultModelArr.split(",")
        } else if (element.options.remote == 2 && !element.options.multiple) {
          var model = this.formModel[element.model]
          var resultModel = ""
          this.remoteSelectData.forEach((item) => {
            console.log(model, item)
            if (item[element.options.remoteData.value] == model) {
              resultModel = item[element.options.remoteData.label]
            }
          })
          return resultModel
        } else if (element.options.remote == 2 && element.options.multiple) {
          var model = this.formModel[element.model + 'SelectBox']
          var resultModelArr = []
          for (var i = 0; i < model.length; i++) {
            this.remoteSelectData.forEach((item) => {
              if (item[element.options.remoteData.value] == model[i]) {
                resultModelArr.push(item[element.options.remoteData.label])
              }
            })
          }
          return resultModelArr.split(",")
        }
      } else if (str == "checkbox") {
        if (element.options.remote == 1) {
          var model = this.formModel[element.model]
          var resultModel = ""
          element.options.option.forEach((item) => {
            console.log(model, item)
            if (item.code == model) {
              resultModel = item.name
            }
          })
          return resultModel
        } else if (element.options.remote == 2) {
          var model = this.formModel[element.model + 'CheckboxModel']
          var resultModelArr = []
          for (var i = 0; i < model.length; i++) {
            element.options.option.forEach((item) => {
              if (item[element.options.remoteData.value] == model[i]) {
                resultModelArr.push(item[element.options.remoteData.label])
              }
            })
          }
          return resultModelArr.split(",")
        }
      } else if (str == "switch") {
        var model = this.formModel[element.model]
        if (model == "0" || model == 0) {
          return "否"
        } else if (model == "1" || model == 1) {
          return "是"
        }
      } else if (str == "input") {
        if (element.type == 'input' && element.options.isThousandthPercentile) {
          return this.formModel[element.model + 'Thousands'] = (this.formModel[element.model] + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
        }
      }
    },
    //所有禁用条件的处理
    allcomponentsDisabledfun(element) {
      if (element.options.disabled) {   //自身禁用
        return true
      } else if (this.permissionSetting(element.options.readonlyRoleList, 'readonly')) {   //权限禁用
        return true
      } else if (this.$store.getters.getcustomformDisabled()) {  //当前应用禁用
        return true
      } else if (this.componentsIsShow(element, element.options.disabledCondition)) {  //当前表单禁用
        return true
      } else {
        return false
      }
    },
    //所有显示隐藏的处理
    allcomponentsIsShow(element) {
      if (element.options.isvisible) {
        return false
      } else if (!(this.permissionSetting(element.options.invisibleRoleList, 'look'))) {
        return false
      } else if (this.componentsIsShow(element, element.options.hideCondition)) {
        return false
      } else {
        return true
      }
    },
    //权限设置方法
    permissionSetting(arr, str) {
      if (!!arr && arr.length != 0) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
          newArr.push(arr[i].name)
        }
        var res = newArr.includes(this.$store.state.currentuser.roleName)
        if (str == 'look') {
          return !res
        } else {
          return res
        }
      } else {
        if (str == 'look') {
          return true
        } else {
          return false
        }
      }
    },
    //组件禁用、隐藏条件解析
    componentsIsShow(element, hideCondition) {
      var str = hideCondition
      if (!!hideCondition) {
        var arr = hideCondition.split('&&')
        var Arr = arr.map((arrItem) => {
          if (arrItem.indexOf('||') !== -1) {
            return arrItem.split("||")
          } else {
            return arrItem
          }
        })
        var newArr = Arr.flat(Infinity)
        if (this.isChild) {
          newArr.forEach((newArrItem) => {
            if (newArrItem.indexOf('(') !== -1) {
              newArrItem = newArrItem.substr(1, newArrItem.length)
              str = this.componentsIsShowChildFunction(newArrItem, str, element)
            } else if (newArrItem.indexOf(')') !== -1) {
              newArrItem = newArrItem.substr(0, newArrItem.length - 1)
              str = this.componentsIsShowChildFunction(newArrItem, str, element)
            }
            str = this.componentsIsShowChildFunction(newArrItem, str, element)
          })
        } else {
          newArr.forEach((newArrItem) => {
            if (newArrItem.indexOf('(') !== -1) {
              newArrItem = newArrItem.substr(1, newArrItem.length)
              str = this.componentsIsShowDetailFunction(newArrItem, str, element)
            } else if (newArrItem.indexOf(')') !== -1) {
              newArrItem = newArrItem.substr(0, newArrItem.length - 1)
              str = this.componentsIsShowDetailFunction(newArrItem, str, element)
            }
            str = this.componentsIsShowDetailFunction(newArrItem, str, element)
          })
        }
        if (str.indexOf(':') == -1) {
          return eval(str)
        }
      } else {
        return false
      }
    },
    //组件禁用、隐藏条件子表解析函数
    componentsIsShowChildFunction(newArrItem, str, element) {
      if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf('m:') !== -1) {
        var Detailfiled = newArrItem.substr(2, newArrItem.indexOf('!==') - 2)
        var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (this.detailInfos[Detailfiled] != filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf('m:') !== -1 && newArrItem.indexOf('==') !== -1) {
        var Detailfiled = newArrItem.substr(2, newArrItem.indexOf('=') - 2)
        var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf('m:') !== -1 && newArrItem.indexOf('==') == -1) {
        var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
        var replaceStr = newArrItem.substr(newArrItem.indexOf('m:'), newArrItem.length)
        if (!!this.detailInfos[Detailfiled]) {
          str = str.replace(replaceStr, true)
        } else {
          str = str.replace(replaceStr, false)
        }
      } else if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
        var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
        var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (this.currentAppChildRowData[Detailfiled] != filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
        var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
        var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (!!this.currentAppChildRowData[Detailfiled] && this.currentAppChildRowData[Detailfiled] == filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
        var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
        var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
        if (!!this.currentAppChildRowData[Detailfiled]) {
          str = str.replace(replaceStr, true)
        } else {
          str = str.replace(replaceStr, false)
        }
      }
      return str
    },
    //组件禁用、隐藏条件主表表解析函数
    componentsIsShowDetailFunction(newArrItem, str, element,) {
      if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
        var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
        var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (this.detailInfos[Detailfiled] != filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
        var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
        var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
        if (filedValue.indexOf('currentuser:') !== -1) {
          filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
        }
        if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
          str = str.replace(newArrItem, true)
        } else {
          str = str.replace(newArrItem, false)
        }
      } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
        var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
        var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
        if (!!this.detailInfos[Detailfiled]) {
          str = str.replace(replaceStr, true)
        } else {
          str = str.replace(replaceStr, false)
        }
      }
      return str
    },
    //必填验证解析
    componentsRules(element) {
      var requireCondition = element.options.requireCondition
      if (!!requireCondition) {
        var arr = requireCondition.split('&&')
        var Arr = arr.map((arrItem) => {
          if (arrItem.indexOf('||') !== -1) {
            return arrItem.split("||")
          } else {
            return arrItem
          }
        })
        var newArr = Arr.flat(Infinity)
        newArr.forEach((newArrItem) => {
          if (newArrItem.indexOf('(') !== -1) {
            newArrItem = newArrItem.substr(1, newArrItem.length)
          } else if (newArrItem.indexOf(')') !== -1) {
            newArrItem = newArrItem.substr(0, newArrItem.length - 1)
          } else if (newArrItem.indexOf('!==') !== -1) {
            var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.indexOf('!==') - 1)
            var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
            if (!!this.formModel[detailFiled]) {
              if (this.formModel[detailFiled] == filedValue) {
                requireCondition = requireCondition.replace(newArrItem, false)
              } else {
                requireCondition = requireCondition.replace(newArrItem, true)
              }
            } else {
              requireCondition = requireCondition.replace(newArrItem, true)
            }
          } else if (newArrItem.indexOf('==') !== -1) {
            var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.indexOf('==') - 1)
            var filedValue = newArrItem.substr(newArrItem.indexOf('==') + 2, newArrItem.length)
            if (!!this.formModel[detailFiled]) {
              if (this.formModel[detailFiled] == filedValue) {
                requireCondition = requireCondition.replace(newArrItem, true)
              } else {
                requireCondition = requireCondition.replace(newArrItem, false)
              }
            } else {
              requireCondition = requireCondition.replace(newArrItem, false)
            }
          } else {      //  表达式 !   和  !!  解析
            var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
            if (!!this.formModel[detailFiled]) {
              requireCondition = requireCondition.replace(':' + detailFiled, true)
            } else {
              requireCondition = requireCondition.replace(':' + detailFiled, false)
            }
          }
        })
        var result = eval(requireCondition)
        if (result) {
          return [{ message: element.name + "必须填写", required: true }]
        } else {
          return element.rules
        }
      } else {
        return element.rules
      }
    },
    //计算域解析数组的方法
    analysisArray(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].indexOf('-') !== -1) {
          arr[i] = arr[i].split("-")
        }
        if (arr[i].indexOf('*') !== -1) {
          arr[i] = arr[i].split("*")
        }
        if (arr[i].indexOf('/') !== -1) {
          arr[i] = arr[i].split("/")
        }
        if (Object.prototype.toString.call(arr[i]) === '[object Array]') {
          this.analysisArray(arr[i])
        }
      }
      return arr
    },
    //递归json获取基础组件信息
    recursionJson(json, arr) {
      json.forEach((item) => {
        if (item.type == 'grid') {
          item.columns.forEach((columnsItem) => {
            this.recursionJson(columnsItem.list, arr)
          })
        } else {
          arr.push(item)
        }
      })
      return arr
    },
    //计算域解析
    computationalDomain(element) {
      //日期清除之后初始化为空字符串
      if(element.type == "date" || element.type == "datetime" || element.type == 'time'){
         if(this.formModel[element.model] == null || this.formModel[element.model] == undefined){
            this.formModel[element.model] = "";
         }
      }
      this.saveChildChangeData()
      if (element.type != 'allDatePicker' && element.type != 'week') {
        if (this.isChild) {  //子表
          var newArr = this.recursionJson(this.childDetailJson, [])
        } else {        //主表
          var newArr = this.detailJosnArr
        }
        this.$nextTick(() => {
          newArr.forEach((item) => {
            if (item.type !== 'grid' && item.type !== 'table' && item.type !== 'tabs') {
              console.log(item)
              if (!!item.options.calculaterule) {    //判断计算域是否存在
                var str = item.options.calculaterule
                if (!item.options.calculateresult) {             //数字计算域
                  var arr = str.split('+')
                  var Arr = this.analysisArray(arr)
                  var newArr = Arr.flat(Infinity)
                  newArr.forEach((newArrItem) => {
                    if (newArrItem.indexOf(':') !== -1) {
                      if (newArrItem.indexOf(')') !== -1) {
                        var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length - 2)
                      } else {
                        var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
                      }
                      if (str.indexOf(detailFiled) !== -1) {
                        str = str.replace(':' + detailFiled, this.formModel[detailFiled])
                      }
                    }
                  })
                  if (item.type == 'number' || item.type == 'numbers') {
                    var teststr = eval(str) + ""
                    if (teststr.indexOf('.') !== -1) {
                      if (eval(str) == -Infinity || eval(str) == Infinity) {
                        this.$set(this.formModel, item.model, 0)
                      } else {
                        this.$set(this.formModel, item.model, eval(str).toFixed(4))
                      }
                    } else {
                      if (eval(str) == -Infinity || eval(str) == Infinity) {
                        this.$set(this.formModel, item.model, 0)
                      } else {
                        this.$set(this.formModel, item.model, eval(str))
                      }

                    }
                  } else if (item.type == 'input') {
                    if (eval(str) == -Infinity || eval(str) == Infinity) {
                      this.$set(this.formModel, item.model, '0')
                    } else {
                      this.$set(this.formModel, item.model, eval(str).toString())
                    }
                  }
                } else if (!!item.options.calculateresult) {      //时间计算域
                  var arr = str.split('+')
                  var Arr = this.analysisArray(arr)
                  var newArr = Arr.flat(Infinity)
                  newArr.forEach((newArrItem) => {
                    if (newArrItem.indexOf(':') !== -1) {
                      var detailFiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
                      if (!!this.formModel[detailFiled]) {
                        var date = new Date(this.formModel[detailFiled]).getTime()
                        str = str.replace(':' + detailFiled, date)
                      } else {
                        str = str.replace(':' + detailFiled, 0)
                      }
                    } else if (newArrItem.indexOf('y') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('y')) * 31536000000))
                    } else if (newArrItem.indexOf('m') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('m')) * 2635200000))
                    } else if (newArrItem.indexOf('d') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('d')) * 86400000))
                    } else if (newArrItem.indexOf('h') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('h')) * 3600000))
                    } else if (newArrItem.indexOf('f') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('f')) * 60000))
                    } else if (newArrItem.indexOf('s') !== -1) {
                      str = str.replace(newArrItem, eval(newArrItem.substr(0, newArrItem.indexOf('s')) * 1000))
                    }
                  })
                  if (item.type == 'input') {
                    if (item.options.calculateresult == 'millisecond') {
                      this.$set(this.formModel, item.model, (eval(str)).toString())
                    } else if (item.options.calculateresult == 'second') {
                      this.$set(this.formModel, item.model, (eval(str) / 1000).toString())
                    } else if (item.options.calculateresult == 'minute') {
                      this.$set(this.formModel, item.model, (eval(str) / 60000).toString())
                    } else if (item.options.calculateresult == 'hour') {
                      this.$set(this.formModel, item.model, ((eval(str) / 3600000).toFixed(2)).toString())
                    } else if (item.options.calculateresult == 'day') {
                      this.$set(this.formModel, item.model, (Math.round((eval(str) / 86400000) + 1)).toString())
                    } else if (item.options.calculateresult == 'week') {
                      this.$set(this.formModel, item.model, (eval(str) / 604800000).toString())
                    } else if (item.options.calculateresult == 'year') {
                      this.$set(this.formModel, item.model, (eval(str) / 31536000000).toString())
                    }
                  } else if (item.type == 'number' || item.type == 'numbers') {
                    if (item.options.calculateresult == 'millisecond') {
                      this.$set(this.formModel, item.model, eval(str))
                    } else if (item.options.calculateresult == 'second') {
                      this.$set(this.formModel, item.model, eval(str) / 1000)
                    } else if (item.options.calculateresult == 'minute') {
                      this.$set(this.formModel, item.model, eval(str) / 60000)
                    } else if (item.options.calculateresult == 'hour') {
                      this.$set(this.formModel, item.model, (eval(str) / 3600000).toFixed(2))
                    } else if (item.options.calculateresult == 'day') {
                      this.$set(this.formModel, item.model, Math.round((eval(str) / 86400000) + 1))
                    } else if (item.options.calculateresult == 'week') {
                      this.$set(this.formModel, item.model, eval(str) / 604800000)
                    } else if (item.options.calculateresult == 'year') {
                      this.$set(this.formModel, item.model, eval(str) / 31536000000)
                    }
                  } else if (item.type == 'datetime' || item.type == 'date' || item.type == 'time') {
                    this.$set(this.formModel, item.model, this.formatDate(new Date(eval(str))))
                  }
                }
              }
            }
          })
        })
        //限制解析
        if (!!element.options.inputLimit) {
          if (element.type !== 'number' && element.type !== 'numbers') {
            var arr = element.options.inputLimit.split('&&')
            var inputLimitStr = element.options.inputLimit
            arr.forEach((inputLimitItem) => {
              var inputLimitFiled = inputLimitItem.substr(2, inputLimitItem.length)
              if (inputLimitItem.indexOf('>') !== -1) {
                if (inputLimitFiled == 'currentTime') {
                  if (new Date().getTime() > new Date(this.formModel[element.model]).getTime()) {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, false)
                  } else {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                  }
                } else {
                  if (!!this.formModel[inputLimitFiled]) {
                    if (new Date(this.formModel[inputLimitFiled]).getTime() > new Date(this.formModel[element.model]).getTime()) {
                      inputLimitStr = inputLimitStr.replace(inputLimitItem, false)
                    } else {
                      inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                    }
                  } else {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                  }
                }
              } else if (inputLimitItem.indexOf('<') !== -1) {
                if (inputLimitFiled == 'currentTime') {
                  if (new Date().getTime() < new Date(this.formModel[element.model]).getTime()) {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, false)
                  } else {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                  }
                } else {
                  if (!!this.formModel[inputLimitFiled]) {
                    if (new Date(this.formModel[inputLimitFiled]).getTime() < new Date(this.formModel[element.model]).getTime()) {
                      inputLimitStr = inputLimitStr.replace(inputLimitItem, false)
                    } else {
                      inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                    }
                  } else {
                    inputLimitStr = inputLimitStr.replace(inputLimitItem, true)
                  }
                }
              }
            })
            var inputLimitStrRes = eval(inputLimitStr)
            if (!inputLimitStrRes) {
              this.$message.warning(element.options.inputLimitTitle)
              this.formModel[element.model] = ''
            }
          }
        }
      }
    },
    //时间戳转时间方法
    formatDate(now) {
      var year = now.getFullYear();  //取得4位数的年份
      var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
      var date = now.getDate();      //返回日期月份中的天数（1到31）
      var hour = now.getHours();     //返回日期中的小时数（0到23）
      var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
      var second = now.getSeconds(); //返回日期中的秒数（0到59）
      return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    },
    //清除弹出框点击
    clearInput(element) {
      this.saveChildChangeData()
      if (element.options.isCustomizedprocessing && !!element.options.clearcustomizedprocessingevent) {
        this.$refs.customizationComponents.clearInputBtnData(element, this.formModel)
      } else {
        var list = element.options.remoteData.displayFieldList
        for (var i = 0; i < list.length; i++) {
          if (!!list[i].replaceField) {
            this.formModel[list[i].replaceField] = ""
          }
        }
      }
    },
    //弹出框点击
    inputBtnClick(element) {
      if (element.options.isBatchChoose) {
        this.$refs.batchPopupComponents.view(element, this.parentRowData)
      } else {
        this.$refs.popupComponents.view(element, {}, this.parentRowData)
      }
    },
    //弹出框选择值之后刷新页面
    updateChoose(param) {
      this.$forceUpdate();
      this.isChild ? this.$set(this.currentAppChildRowData) : this.$set(this.detailInfos)
      this.saveChildChangeData()
    },
    //树弹出框点击
    treeinputBtnClick(element) {
      this.$refs.treePopupComponents.view(element)
    },
    //获取下拉框数据
    getRemoteSelectData() {
      //下拉框获取数据字典
      if (this.element.type == 'select' && this.element.options.remote == 1 && !!this.element.options.dictionaryCode) {
        var url = Config.dev_url + '/api-user/dicts/findByCode?code=' + this.element.options.dictionaryCode;
        this.$axios.get(url).then((res) => {
          this.dictSelectData = res.data.subDicts;
        }).catch((err) => {
        });
      }
      //下拉框获取自定义远端数据值
      if (this.element.type == 'select' && this.element.options.remote == 2) {
        var obj = {}
        var methods = this.element.options.remoteData.methods;  //查询方式
        var options = this.element.options.remoteData.options   //查询参数
        // 处理查询条件
        for (var i = 0; i < options.length; i++) {
          if (!!options[i].key && !!options[i].value) {  //判断查询条件参数是否存在
            if (options[i].isFixedValue) {    //判断查询条件的value值是否是固定值
              obj[options[i].key] = options[i].value
            } else {   //非固定值，从主表信息中取值
              obj[options[i].key] = this.formModel[options[i].value]
            }
          }
        }
        //根据请求方式判断传参形式
        if (methods == 'get') {
          if (JSON.stringify(obj) == "{}") {
            var url = Config.dev_url + this.element.options.remoteData.url
          } else {
            var str = ''
            for (let key in obj) {
              str += key + '=' + obj[key] + '&'
            }
            var params = str.substring(0, str.length - 1)
            var url = Config.dev_url + this.element.options.remoteData.url + '?' + params
          }
          this.$axios.get(url).then((res) => {
            this.remoteSelectData = res.data.data
          }).catch((err) => {
          });
        } else if (methods == 'post') {
          var url = Config.dev_url + this.element.options.remoteData.url
          this.$axios.post(url, obj).then((res) => {
            this.remoteSelectData = res.data.data
          }).catch((err) => {
          });
        }
      }
    },
    getCheckboxData() {
      if (this.element.type == 'checkbox' || this.element.type == 'radio') {
        console.log(this.element)
        if (this.element.options.remote == 1 && !!this.element.options.dictionaryCode) {
          var url = Config.dev_url + '/api-user/dicts/findByCode?code=' + this.element.options.dictionaryCode;
          this.$axios.get(url).then((res) => {
            this.element.options.options = res.data.subDicts;
          });
        } else if (this.element.options.remote == 2) {
          var obj = {}
          var methods = this.element.options.remoteData.methods;  //查询方式
          var options = this.element.options.remoteData.options   //查询参数
          // 处理查询条件
          for (var i = 0; i < options.length; i++) {
            if (!!options[i].key && !!options[i].value) {  //判断查询条件参数是否存在
              if (options[i].isFixedValue) {    //判断查询条件的value值是否是固定值
                obj[options[i].key] = options[i].value
              } else {   //非固定值，从主表信息中取值
                if (JSON.stringify(obj) != "{}") {
                  obj[options[i].key] = this.formModel[options[i].key]
                } else {
                  return false
                }
              }
            }
          }
          console.log(obj)
          if (methods == 'get') {
            if (JSON.stringify(obj) == "{}") {
              var url = Config.dev_url + this.element.options.remoteData.url
            } else {
              var str = ''
              for (let key in obj) {
                str += key + '=' + obj[key] + '&'
              }
              var params = str.substring(0, str.length - 1)
              var url = Config.dev_url + this.element.options.remoteData.url + '?' + params
            }
            this.$axios.get(url).then((res) => {
              console.log(res)
              this.element.options.options = res.data.data
            })
          } else if (methods == 'post') {
            var url = Config.dev_url + this.element.options.remoteData.url
            this.$axios.post(url, obj).then((res) => {
              this.element.options.options = res.data.data
            })
          }
        }
      }
    },
  },
  mounted() {
    this.getRemoteSelectData()
    this.getCheckboxData()
  }
}
</script>

<style>
</style>
